<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else id="management" class="box">
    <div class="row">
      <div class="col-4">
        <h4>Contracts</h4>
        <form v-for="(contract,index) in contractList" :key="index" :id="'contract-form-'+index" @submit.prevent="updateContract(index)">
          <div class="form-group">
            <div class="form-row">
              <div class="col">
                <input type="text" class="form-control details-input" :class="getSavingClass('contract-'+index)" :id="'contract-'+index" v-model="contractList[index]" required>
              </div>
              <div class="col">
                <button class="btn btn-primary">Save</button>
                <button type="button" class="btn btn-danger" @click="deleteContract(index)">Delete</button>
              </div>
            </div>
          </div>
        </form>
        <div>
          <button type="button" class="btn btn-success" @click="addContract()">Add Contract</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'GroupModify',
  components: {
    VueLoading
  },
  props: [
    'id'
  ],
  data () {
    return {
      loading: false,
      isSaving: false,
      contractList: []
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'contracts'
    ])
  },
  watch: {
    id: function () {
      if (this.groups.includes(this.id)) {
        this.getContractGroups()
      } else if (this.contracts.includes(this.id)) {
        this.$router.push({ name: 'ContractModify', params: { id: this.id } })
      } else {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  created: function () {
    this.getContractGroups()
  },
  methods: {
    getContractGroups: function () {
      this.loading = true
      HTTP.get(`/management/group/${this.id}`)
        .then(response => {
          this.contractList = response.data.contracts
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to retrieve contracts for ${this.id} : ${msg}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteContract: function (index) {
      this.isSaving = 'contract-' + index
      var contract = this.contractList[index]
      if (!contract) {
        this.contractList.splice(index, 1)
      } else if (confirm('are you sure you want to remove the ' + contract + ' from the "' + this.id + '" contract group?')) {
        HTTP.delete(`/management/group/${this.id}/contract/${contract}`)
          .then(() => {
            this.flashMessage.success({
              message: `Successfully removed ${contract} from the ${this.id} contract group`
            })
            this.contractList.splice(index, 1)
          })
          .catch((error) => {
            this.isSaving = 'contract-' + index + '-error'
            var msg = (error.response) ? error.response.data.error : error.message
            this.flashMessage.error({
              message: `Failed to removed ${contract} from the ${this.id} contract group : ${msg}`
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    updateContract: function (index) {
      this.isSaving = 'contract-' + index
      var contract = this.contractList[index]
      HTTP.put(`/management/group/${this.id}/contract/${contract}`)
        .then(() => {
          this.isSaving = 'contract-' + index + '-success'
          this.flashMessage.success({
            message: `Successfully added ${contract} from the ${this.id} contract group`
          })
        })
        .catch((error) => {
          this.isSaving = 'contract-' + index + '-error'
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to add ${contract} to the ${this.id} contract group : ${msg}`
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.isSaving = false
          }, 3000)
        })
    },
    addContract: function () {
      this.contractList.push(null)
    },
    getSavingClass: function (type) {
      return [
        {'input-saving': this.isSaving === type},
        {'input-success': this.isSaving === type + '-success'},
        {'input-error': this.isSaving === type + '-error'}
      ]
    }
  }
}
</script>

<style scoped>
h4 {
  margin-top: 15px;
}
.row {
  padding: 20px;
}
.account-rows {
  padding-bottom: 10px;
}
.details-input {
  max-width: 300px;
  margin-right: 20px;
  float: left;
}
.details-remove-btn {
  float: left;
}
.slack-submit {
  float: left;
}
.text-input {
  max-width: 300px;
  margin-bottom: 10px;
}
.input-saving {
  border-color: #70A1F0;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  box-shadow: 0 0 5px #70A1F0;
}
.input-success {
  border-color: #12961a;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  box-shadow: 0 0 5px #12961a;
}
.input-error {
  border-color: #e94949;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  box-shadow: 0 0 5px #e94949;
}
</style>

<style scoped src='../assets/stylesheet/transitions.css'></style>



// WEBPACK FOOTER //
// src/views/GroupModify.vue